// Shared localStorage draft helpers for the setup wizards.

export const readDraft = key => {
  try {
    return JSON.parse(localStorage.getItem(key)) || null
  } catch {
    return null
  }
}

export const writeDraft = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    return
  }
}

export const clearDraft = key => {
  try {
    localStorage.removeItem(key)
  } catch {
    return
  }
}

export const isPlainObject = value => value !== null && typeof value === 'object' && !Array.isArray(value)

// Copies saved values onto the matching keys of a default draft, ignoring keys the
// default no longer has. `hydrate(key, saved)` may return a replacement for a key whose
// default is null (so a saved object can be rebuilt into its richer shape); returning
// undefined leaves the key alone. A saved list replaces a null default. A default that
// is an empty plain object is an open map (keyed by id), so the saved object is taken
// wholesale. With `sameType`, a saved scalar only replaces a default that is null or of
// the same type.
export const mergeDraft = (target, source, { hydrate, sameType = false } = {}) => {
  if (!isPlainObject(source)) return target
  const fits = (current, saved) => !sameType || current === null || typeof current === typeof saved
  Object.keys(target).forEach(key => {
    if (!(key in source)) return
    const saved = source[key]
    if (isPlainObject(target[key])) {
      if (Object.keys(target[key]).length === 0 && isPlainObject(saved)) target[key] = saved
      else mergeDraft(target[key], saved, { hydrate, sameType })
    } else if (target[key] === null && isPlainObject(saved) && hydrate?.(key, saved) !== undefined)
      target[key] = hydrate(key, saved)
    else if (target[key] === null && Array.isArray(saved)) target[key] = saved
    else if (Array.isArray(target[key])) target[key] = Array.isArray(saved) ? saved : target[key]
    else if (!isPlainObject(saved) && !Array.isArray(saved) && fits(target[key], saved)) target[key] = saved
  })
  return target
}
